import React,{useState, useEffect}  from 'react';
import {Card} from 'react-bootstrap'
import Sides from '../Bars/Diffjvscs';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jcsswitch(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  

return(
    <div>
    <Sides/>
      <Helmet>
 
      <title>Difference Between Java and C# Switch tutorial For Beginners</title>
<meta name="description" content="Difference Between Java and C# Switch tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, java tutorial,c# tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,Switch,tutorial for begineers,Difference Between Java and Csharp(C#),Difference between program and code,java tutorial for begineers,C# tutorial for begineers,java tutorial for begineers,code,exampler,which online website to learn code,Difference Between Java and C# ,java vs Csharp Switch,java vs Python," />
<link rel="canonical" href="https://www.codeexampler.com/java-vs-csharp-switch" />
</Helmet>
<div className='lg:pl-56'>
    <h1 className="m-4 mh1">Java vs C# switch</h1>
    <div className="first">
        <a href="/java-vs-csharp-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-csharp-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-3 para">This Switch case in java is also used in multiple conditions having different statements like-if else if but it can check only equality of the condition floating point but value can’t be check by the switch.</p>


  

<h2 className="mt-4 mh2">
The Syntax for the switch in java</h2>
<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">The syntax for switch statement java:
</Card.Header>
  <Card.Body>
    <Card.Text>
    Switch (variable)<br/>
    &#123;<br/>
Case 1:<br/>
Statement;<br/>
Case 2:<br/>
Statement;<br/>
Default:<br/>
Statement;<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
  
</Card>

<h2 className="mt-4 mh2">
c# switch statement syntax</h2>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">The syntax for switch statement C#:
</Card.Header>
  <Card.Body>
    <Card.Text>
        namespace switch<br/>
        &#123;<br/>
    Switch (variable)<br/>
    &#123;<br/>
Case 1:<br/>
Statement;<br/>
Case 2:<br/>
Statement;<br/>
Default:<br/>
Statement;<br/>
&#125;<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
 
</Card>

<h2 className="mt-4 mh2">
java Switch Example</h2>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-Write a program to input a no and print month name and if no is 2 in Java Example?
</Card.Header>
  <Card.Body>
  
    <Card.Text>
    public class Switch_example &#47;&#47; class is a keyword<br/>
    &#123;<br/>
    public static void main(String[] args) <br/>
&#123;<br/>
int i=3; <br/>
switch(i)<br/>
&#123;<br/>
Case 1:<br/>
System.out.println("January");<br/>
Case 2:<br/>
System.out.println("February"); <br/>
Case 3:<br/>
System.out.println("March"); <br/>
default:<br/>
System.out.println("Default Value"); <br/>
&#125;<br/>
&#125;<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/> March<br/> Default value</Card.Footer>
</Card>

<h3 className="mt-4">C# switch Example</h3>

<Card className='inde' border='primary m-4'>
<Card.Header as="h5">Q-Write a program to input a no  and print month name and if no is 2 by using switch break in CSharp Example?
</Card.Header>
  <Card.Body>
  
    <Card.Text>
    namespace switch<br/>
    &#123;<br/>
    class Program<br/>
    &#123;<br/>
        static void Main(string[] args)<br/>
        &#123;<br/>
        int month = 3;<br/> 
            switch (month)<br/> 
&#123;<br/>
case 1:
        Console.WriteLine("jan");<br/>
      break;<br/>
    case 2:<br/>
       Console.WriteLine("feb");<br/>
     break;<br/>
    case 3:<br/>
   Console.WriteLine("march");<br/>
     break;<br/>
      default:<br/>
        Console.WriteLine("default");<br/>
  break;<br/>
&#125;<br/>
&#125;<br/>
&#125;<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/>march</Card.Footer>
</Card>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="java-vs-csharp-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-csharp-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jcsswitch;